<template>
  <div class="aside article__aside">
    <div class="aside__inner sticky" style="position: sticky; top: 16px;">
      <aside class="dictionary-menu">
        <help-links></help-links>
        <div v-if="highlightCount" class="highlighter">
          <div class="query">
            <span>Поиск: <i>{{ $route.query.query }}</i></span>
          </div>
          <div class="nav-buttons">
            <div>
              <span>{{ highlightIndex + 1 }}/{{ highlightCount }}</span>
            </div>
            <div class="chevron">
                <a @click.prevent="scrollToHighlight('decrease')" :href="prevHighlightAnchor"> < </a>
                <a @click.prevent="scrollToHighlight('increase')"> > </a>
            </div>
          </div>
        </div>
        <article-title
            class="dictionary-title"
            style="margin: 0"
            :title="postHelper.title"
            :full_title="postHelper.full_title"
        ></article-title>
<!--        <div class="dictionary-title" v-html="postHelper.title"></div>-->
        <div class="dictionary-contents">
          <ul class="dictionary-list">
            <li
              v-if="postHelper.reminders"
              :class="{
                'dictionary-list__item': true,
                active: !remindersHide,
              }"
            >
              <a
                href="#reminders"
                class="dictionary-list__link"
                @click="remindersClickHandler"
              >
                Обновления
              </a>
            </li>
            <li v-if="postHelper.images" class="dictionary-list__item">
              <gallery-button :gallery="postHelper.images"></gallery-button>
            </li>
            <li
              v-if="postHelper.contents && postHelper.contents.length"
              :class="{
                'dictionary-list__item dictionary-list__dropdown': true,
                drop: contentsShow,
              }"
            >
              <a
                href="#"
                class="dictionary-list__link"
                @click.prevent="contentsShow = !contentsShow"
              >
                Содержание
              </a>
              <ul class="dictionary-list" v-show="contentsShow">
                <li
                  v-for="(anchorLink, linkIndex) in postHelper.contents"
                  :class="{
                    'dictionary-list__item': true,
                    'dictionary-list__dropdown sub drop': checkChildren(
                      anchorLink
                    ),
                  }"
                  :key="linkIndex"
                >
                  <a
                    v-if="anchorLink.anchor"
                    @click="contentsClickHandler(anchorLink.anchor)"
                    :href="'#' + anchorLink.anchor"
                    :class="{
                      'dictionary-list__link': true,
                      title: checkChildren(anchorLink),
                      active: anchorLink.anchor === activePostParagraph,
                    }"
                  >
                    {{ anchorLink.title }}
                  </a>
                  <span v-else>{{ anchorLink.title }}</span>
                  <a
                    v-if="checkChildren(anchorLink)"
                    href="#"
                    class="dictionary-list__link chevron drop"
                    @click.prevent="toggleClass"
                  ></a>
                  <ul v-if="checkChildren(anchorLink)" class="dictionary-list">
                    <li
                      v-for="(subCategoryLink,
                      subLinkIndex) in anchorLink.children"
                      class="dictionary-list__item"
                      :key="subLinkIndex"
                    >
                      <a
                        v-if="subCategoryLink.anchor"
                        @click="
                          contentsClickHandler(subCategoryLink.anchor, true)
                        "
                        :href="'#' + subCategoryLink.anchor"
                        :class="{
                          'dictionary-list__link': true,
                          active:
                            anchorLink.anchor === activePostParagraph &&
                            subCategoryLink.anchor === activeSubParagraph,
                        }"
                      >
                        {{ subCategoryLink.title }}
                      </a>
                      <span v-else>{{ subCategoryLink.title }}</span>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li v-if="postHelper.links" class="dictionary-list__item">
              <a
                @click.prevent="
                  callModal({ type: 'list', param: postHelper.links })
                "
                class="dictionary-list__link"
                href="#"
                >Резюме доказательств (пример)</a
              >
            </li>
            <li
              v-if="false && postHelper.references && postHelper.references.length"
              :class="{
                'dictionary-list__item dictionary-list__dropdown': true,
                drop: referencesShow,
              }"
            >
              <a
                href="#"
                class="dictionary-list__link"
                @click.prevent="referencesShow = !referencesShow"
              >
                Референсные ссылки
              </a>
              <ul class="dictionary-list" v-show="referencesShow">
                <li
                  v-for="(referenceLink, linkIndex) in postHelper.references"
                  class="dictionary-list__item"
                  :key="linkIndex"
                  v-html="referenceLink.content"
                ></li>
              </ul>
            </li>
            <li
                v-if="postHelper.related && postHelper.related.length > 0"
                :class="{
                'dictionary-list__item dictionary-list__dropdown': true,
                drop: relatedArticlesShow,
              }"
            >
              <a
                  href="#"
                  class="dictionary-list__link"
                  @click.prevent="relatedArticlesShow = !relatedArticlesShow"
              >
                Связанные статьи
              </a>
              <ul class="dictionary-list" v-show="relatedArticlesShow">
                <li
                    v-for="(relatedArticle, linkIndex) in postHelper.related"
                    class="dictionary-list__item"
                    :key="linkIndex"
                >
                  <div class="dictionary-list__link">
                    <div>
                      <a class="dictionary-list__link" :href="generatePath(relatedArticle.base_id, relatedArticle.title)" target="_blank" v-html="relatedArticle.title"></a>
                    </div>
                    <div>
                      <span class="shadow">{{relatedArticle.category}}</span>
                    </div>
                  </div>
                </li>
                <li class="dictionary-list__item">
                  <div class="dictionary-list__link">
                    <div>
                      <a
                          @click.prevent="pushToSearch"
                          class="dictionary-list__link"
                          href="#">
                        <svg class="inline-svg search-icon prepend">
                          <use xlink:href="#search"></use>
                        </svg>
                        <b>Больше материалов по коду {{shortBaseId.toUpperCase()}}</b>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
            <li
                v-if="postHelper.similar && postHelper.similar.length > 0"
                :class="{
                'dictionary-list__item dictionary-list__dropdown': true,
                drop: similarArticlesShow,
              }"
            >
              <a
                  href="#"
                  class="dictionary-list__link"
                  @click.prevent="similarArticlesShow = !similarArticlesShow"
              >
                Похожие материалы
              </a>
              <ul class="dictionary-list" v-show="similarArticlesShow">
                <li
                    v-for="(similarArticle, linkIndex) in postHelper.similar"
                    class="dictionary-list__item"
                    :key="linkIndex"
                >
                  <div class="dictionary-list__link">
                    <div>
                      <a class="dictionary-list__link" :href="generatePath(similarArticle.base_id, similarArticle.title)" target="_blank">{{similarArticle.title}}</a>
                    </div>
                    <div>
                      <span class="shadow">{{similarArticle.category}}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
            <li
                v-if="postHelper.also_read && postHelper.also_read.length > 0"
                :class="{
                'dictionary-list__item dictionary-list__dropdown': true,
                drop: alsoReadArticlesShow,
              }"
            >
              <a
                  href="#"
                  class="dictionary-list__link"
                  @click.prevent="alsoReadArticlesShow = !alsoReadArticlesShow"
              >
                С этой статьёй читают
              </a>
              <ul class="dictionary-list" v-show="alsoReadArticlesShow">
                <li
                    v-for="(alsoReadArticle, linkIndex) in postHelper.also_read"
                    class="dictionary-list__item"
                    :key="linkIndex"
                >
                  <div class="dictionary-list__link">
                    <div>
                      <a class="dictionary-list__link" :href="generatePath(alsoReadArticle.base_id, alsoReadArticle.title)" target="_blank">{{alsoReadArticle.title}}</a>
                    </div>
                    <div>
                      <span class="shadow">{{alsoReadArticle.category}}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HelpLinks from "@/_components/ui/HelpLinks";
import GalleryButton from "@/_components/ui/GalleryButton";
import ArticleTitle from "@/_components/blocks/article/ArticleTitle";
export default {
  name: "ArticleHelper",
  components: {ArticleTitle, HelpLinks, GalleryButton },
  data() {
    return {
      contentsShow: true,
      referencesShow: false,
      activePostParagraph: "#section_inner_1",
      activeSubParagraph: "",
      relatedArticlesShow: false,
      similarArticlesShow: false,
      alsoReadArticlesShow: false,
    };
  },
  computed: {
    ...mapGetters({
      highlightState: "getHighlightState",
      highlightCount: "getHighlightsCount",
      highlightIndex: "getHighlightsIndex",
      postHelper: "getHelperData",
      remindersHide: "getHelperRemindersHideState",
      isAutoFilter: "getAutoFilterOption",
    }),
    nextHighlightAnchor() {
      return "#highlight_" + (this.highlightIndex + 1);
    },
    shortBaseId() {
      return this.postHelper.base_id ? this.postHelper.base_id.split('.')[0] : '';
    },
    prevHighlightAnchor() {
      return "#highlight_" + (this.highlightIndex - 1);
    },
  },
  mounted() {
    document.addEventListener("scroll", this.scrollHandler);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollHandler);
  },
  methods: {
    ...mapActions({
      callModal: "showModal",
      setHIndex: "setHighlightIndex",
      callPrintArticle: "callPrint",
      toggleRemindersShow: "toggleHelperRemindersState",
      hideReminders: "hideHelperRemindersState",
      setFilter: "setCategoriesFilter",
    }),
    pushToSearch() {
      if (this.isAutoFilter) {
        this.setFilter([]);
      }
      this.$router.push(`/search/results?query=${this.shortBaseId}`);
    },
    generatePath(baseId, title) {
      return `/post/${baseId}-${this.$options.filters.translateUrl(title)}`;
    },
    scrollToHighlight(action) {
      if (action === "increase") {
        if (this.highlightIndex === this.highlightCount - 1) {
          this.setHIndex(0)
        } else {
          this.setHIndex(this.highlightIndex + 1);
        }
      } else {
        if (this.highlightIndex <= 0) {
          this.setHIndex(this.highlightCount - 1)
        } else {
          this.setHIndex(this.highlightIndex - 1);
        }
      }
      location.hash = "#highlight_" + this.highlightIndex;
    },
    formatDate(date) {
      const d = new Date(date);
      const values = [d.getDate(), d.getMonth() + 1];
      for (let id in values) {
        values[id] = values[id].toString().replace(/^([0-9])$/, "0$1");
      }
      return "" + values[0] + "." + values[1] + "." + d.getFullYear();
    },
    checkChildren(item) {
      return item.children && item.children.length > 0;
    },
    contentsClickHandler(anchor, innerParagraph = false) {
      if (!innerParagraph) {
        setTimeout(() => {
          this.activePostParagraph = anchor;
        }, 100);
      }
      this.hideReminders();
    },
    remindersClickHandler() {
      this.activePostParagraph = null;
      this.toggleRemindersShow();
    },
    scrollHandler() {
      // const intViewportHeightOffset = window.innerHeight / 3;
      const intViewportHeightOffset = 100;
      try {
        this.activePostParagraph = [
          ...document.querySelectorAll(".article-sections > div"),
        ]
            .find((node) => {
              return (
                  node.getBoundingClientRect().y +
                  node.getBoundingClientRect().height >
                  intViewportHeightOffset
              );
            })
            .getAttribute("id");
      } catch (e) {
        this.activePostParagraph = "";
      }
      try {
        this.activeSubParagraph = [
          ...document.querySelectorAll(".topic.nested2"),
        ]
          .find((node) => {
            return (
              node.getBoundingClientRect().y +
                node.getBoundingClientRect().height >
              intViewportHeightOffset
            );
          })
          .getAttribute("id");
      } catch (e) {
        this.activeSubParagraph = "";
      }
    },
    toggleClass(ev) {
      let elem = ev.target;
      elem.closest("li.dictionary-list__dropdown").classList.toggle("drop");
    },
  },
};
</script>

<style lang="scss" scoped>
.search-icon.prepend {
  width: 24px;
  height: 24px;
  margin-top: -4px;
  margin-left: -8px;
}
 .shadow {
   opacity: 0.5;
 }
.related-link {
  text-decoration: none;
  font-weight: 400;
}
.dictionary-contents > .dictionary-list > li {
  margin-bottom: 8px;
}
</style>
